export default __webpack_public_path__ + "static/media/coursera.e253df8d.svg";